import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import stripXss from '../../utils/helpers/stripXSS';
import play_video_icon from '../../assets/images/video-background.png';

class ProductPreviewGallery extends Component {

    constructor(props) {
        super(props);

        this.state = {
            galleryData  : this.formatGalleryData(props.media_artifacts)
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ galleryData : this.formatGalleryData(nextProps.media_artifacts) })
    };

    formatGalleryData = (artifacts) => {
        let images = [];

        /* Note : icon_image comes back as empty array if there is no data and as an object if there is data . revisit when MM-4696 is done */
        if(artifacts.icon_image  &&  artifacts.icon_image.url) {
            images.push({original: artifacts.icon_image.url, thumbnail: artifacts.icon_image.url})
        }

        if (artifacts.gallery_images.length) {
            const urls = artifacts.gallery_images.map(item => item.url);
            for (let i = 0; i < urls.length; i++) {
                images.push({
                    original: urls[i],
                    thumbnail: urls[i]
                });
            }
        }
        let videos  = [];
        const video_urls = artifacts.video_urls;
        if (video_urls.length) {
            for (let i = 0; i < video_urls.length; i++) {
                if (video_urls[i] !== "") {
                    videos.push({
                        original: play_video_icon,
                        thumbnail: play_video_icon,
                        description: <span dangerouslySetInnerHTML={{__html: stripXss(`<a href=${(video_urls[i])} target='_blank'>Play</a>`) }} />
                    });
                }
            }
        }

        return images.concat(videos);

        //formatGalleryData = artifacts => (artifacts ? artifacts.map(original => ({original, thumbnail:original})):[]);
    };

    render() {


        return (
            this.props.media_artifacts.icon_image || this.props.media_artifacts.gallery_images.length || (this.props.media_artifacts.video_urls.length && this.props.media_artifacts.video_urls[0] !=="") ? <ImageGallery items={this.state.galleryData} showPlayButton={false} showFullscreenButton={false} /> : ""
        );
    }

}

ProductPreviewGallery.propTypes = {
    media_artifacts    : PropTypes.object.isRequired
};

export default ProductPreviewGallery;